import React, {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {Button, IconButton, Tooltip} from '@mui/material';
import {ITableColumn, ITableGroups, TableColumnType, TableList} from 'src/components/table';
import {useForm} from 'react-hook-form';
import {zodResolver} from '@hookform/resolvers/zod';
import {ICON_MAS} from 'src/pages/sistema/components/SharedIcons';
import CardActions from 'src/pages/sistema/components/CardActions';
import DeleteIcon from '@mui/icons-material/Delete';
import {useConfirmationDialog} from 'src/hooks/useConfirmationDialog';
import {HttpCacheOperacion} from 'src/pages/sistema/api/httpCacheOperacion';
import {EntityWithIdAndDescriptionFields, EntityWithIdFields} from 'src/types';
import {v4 as uuid} from 'uuid'
import {OperacionCLFBDetalleFields} from "../types/fields";
import {OperacionCLFBHoldingPeriodsVista} from "../../../types/clfb";
import {detalleProvisional, DetalleProvisional} from "../types/types";
import SeccionCLFBDatosAdicionalesDialog from "./SeccionCLFBDatosAdicionalesDialog";

const AsyncLabel = ({codActivoTipo, codPais}: { codActivoTipo: number, codPais: number }) => {

  const [label, setLabel] = useState<string>()

  useEffect(() => {
    HttpCacheOperacion.getActivoTipos(codPais)
      .then(activos => {
        const a = activos.find(activo =>
          activo[EntityWithIdFields.Id] === codActivoTipo
        )?.[EntityWithIdAndDescriptionFields.Description]

        setLabel(a)
      })
  }, [codActivoTipo])

  return !label ? <></> : <>{label}</>
}

export const SeccionCLFBDatosDetalleNuevo = (
  {
    codPais,
    detallesProvisionales,
    setDetallesProvisionales,
    adicionales,
  }: {
    codPais: number,
    detallesProvisionales: DetalleProvisional[],
    setDetallesProvisionales: Dispatch<SetStateAction<DetalleProvisional[]>>,
    adicionales?: React.ReactElement;
  }) => {

  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [holdingPeriods, setHoldingPeriods] = useState<OperacionCLFBHoldingPeriodsVista[]>([])

  const {askConfirmation} = useConfirmationDialog();

  useEffect(() => {
    HttpCacheOperacion.getHoldingPeriods(codPais).then(setHoldingPeriods)
  }, [codPais])

  const columnsTablaCLFBDetalle: ITableColumn[] = [
    {
      label: 'Tipo Activo',
      onRenderCell: (entity: DetalleProvisional) =>
        {

          return (
            entity[OperacionCLFBDetalleFields.CodOperacionActivoTipo]
              ? <AsyncLabel codActivoTipo={entity[OperacionCLFBDetalleFields.CodOperacionActivoTipo] || 0} codPais={codPais}/>
              :<>{entity[OperacionCLFBDetalleFields.DescOperacionActivoTipo]}</>
          )

        }


    },
    {label: 'Límite Neto', value: OperacionCLFBDetalleFields.CreditLimitNeto, type: TableColumnType.Decimal},
    {label: 'Límite Absoluto', value: OperacionCLFBDetalleFields.CreditLimitAbsoluto, type: TableColumnType.Decimal},
    {
      label: 'Concentracion Máxima',
      value: OperacionCLFBDetalleFields.CreditLimitConcentracionMaxima,
      type: TableColumnType.Decimal
    },
    {label: 'Verde', value: OperacionCLFBDetalleFields.StopLossRoja},
    {label: 'Amarilla', value: OperacionCLFBDetalleFields.StopLossAmarilla},
    {label: 'Roja', value: OperacionCLFBDetalleFields.StopLossVerde},
    {label: 'Verde', value: OperacionCLFBDetalleFields.HoldingPeriodVerde},
    {label: 'Amarilla', value: OperacionCLFBDetalleFields.HoldingPeriodAmarilla},
    {label: 'Roja', value: OperacionCLFBDetalleFields.HoldingPeriodRoja},
    {
      label: 'Acciones', onRenderCell: (entity: DetalleProvisional) => (
        <Tooltip title='Eliminar'>
          <IconButton
            onClick={
              () => askConfirmation(
                () => setDetallesProvisionales(
                  dts => dts.filter(dt => dt.idProvisional !== entity.idProvisional)
                )
              )
            }
          >
            <DeleteIcon color='error'/>
          </IconButton>
        </Tooltip>
      ),
      width: 0.1
    }
  ]


  const gruposTablaCLFBDetalle: ITableGroups[] = [
    {firstColumn: 1, lastColumn: 3, label: 'Credit Limits'},
    {firstColumn: 4, lastColumn: 6, label: 'Stop Loss'},
    {firstColumn: 7, lastColumn: 9, label: 'Holding Period'},
  ]

  const {control, handleSubmit, reset, formState: { errors }} = useForm<DetalleProvisional>({

     resolver: zodResolver(detalleProvisional),

    defaultValues: {
      [OperacionCLFBDetalleFields.IdProvisional]: uuid(),
      [OperacionCLFBDetalleFields.IdOperacion]: 1,
      [OperacionCLFBDetalleFields.DescOperacionActivoTipo]: null,
    }
  });

  const alGuardarDetalleProvisional = (data: DetalleProvisional) => {
    console.log('holaholahola')
    console.log(errors)
    const nuevoDetalle: DetalleProvisional = {
      ...data,
      idProvisional: uuid(),
    }
    setDetallesProvisionales(prev => [...prev, nuevoDetalle])
    reset()
    setOpenDialog(false)
  }

  const onSubmitFail = (errors: any) => {
    console.error('Form validation errors', errors);
  };

  return (
    <CardActions
      title={"Detalle"}
      actions={
        <Button variant="contained" color="primary" endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
          Nuevo
        </Button>
      }
      colapsable
      tableContent
    >
      <TableList
        entityList={detallesProvisionales}
        columns={columnsTablaCLFBDetalle}
        columnGroups={gruposTablaCLFBDetalle}
        isLoading={false}
        error={false}
        footer={adicionales}
      />

      {
        openDialog &&
          <SeccionCLFBDatosAdicionalesDialog
              open={openDialog}
              codPais={codPais} control={control}
              onClose={() => setOpenDialog(false)}
              onSubmit={handleSubmit(alGuardarDetalleProvisional, onSubmitFail)}
              dialogTitle={'Nuevo Activo'}
          />


      }
    </CardActions>
  )
}
